import type {
  ModalProps,
  DialogProps,
} from '@quero-delivery/quero-components-web';
import { Modal, Dialog } from '@quero-delivery/quero-components-web';
import type { FC } from 'react';
import useScreenType from './useScreenType';

const DialogComponent = Dialog as FC<DialogProps>;
const ModalComponent = Modal as FC<ModalProps>;

type DefaultProps = typeof ModalComponent.defaultProps &
  typeof DialogComponent.defaultProps;

function useModal(defaultProps?: DefaultProps) {
  const isMobile = useScreenType('mobile');

  DialogComponent.defaultProps = { maxHeight: '85%', ...defaultProps };
  ModalComponent.defaultProps = { ...defaultProps };

  if (isMobile) {
    return DialogComponent;
  }

  return ModalComponent;
}

export default useModal;
